import { NgModule } from '@angular/core'
import { EventFilterListComponent } from './event-filter-list.component'
import { CommonModule } from '@angular/common'
import { EventListItemComponentModule } from '../event-list-item/event-list-item.component.module'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../../../../shared/shared.module'

@NgModule({
  imports: [CommonModule, EventListItemComponentModule, RouterModule, SharedModule],
  exports: [EventFilterListComponent],
  declarations: [EventFilterListComponent]
})
export class EventFilterListModule {}
